import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";
import { cn } from "@/lib/utils";

function Tabs(props: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root {...props} />;
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn(
        "inline-flex max-w-full items-center gap-0.5 overflow-x-auto rounded-md bg-muted p-0.75",
        className,
      )}
      {...props}
    />
  );
}

/**
 * An active tab is an olive chip and stays olive on hover. A disabled tab is a flat muted fill,
 * never faded.
 */
function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "inline-flex h-11 min-w-11 items-center justify-center rounded-sm px-3 text-[0.8125rem] font-medium whitespace-nowrap text-muted-foreground transition-colors outline-none md:h-7.5 md:min-w-0",
        "hover:text-foreground",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        // A selected tab is navigation, not the page's primary action. Both were bg-primary,
        // so on /approvals the selected tabs and the "Approve" button were the same lemon fill
        // and a scan of the page found no focal point for the one irreversible control.
        "data-[state=active]:bg-card data-[state=active]:font-semibold data-[state=active]:text-foreground data-[state=active]:shadow-2xs",
        "hover:data-[state=active]:bg-card",
        "disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content className={cn("mt-3 outline-none", className)} {...props} />;
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
